import { useState, useEffect, createContext, useContext } from 'react';
import { getSubscriptionStatus } from '../services/api';
import { useAuth } from '../context/AuthContext';

const SubscriptionContext = createContext(null);

export function SubscriptionProvider({ children }) {
  const { user } = useAuth();
  const [subscription, setSubscription] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) {
      setSubscription(null);
      setLoading(false);
      return;
    }
    getSubscriptionStatus()
      .then(res => setSubscription(res.data))
      .catch(() => setSubscription({ status: 'expired', is_active: false }))
      .finally(() => setLoading(false));
  }, [user]);

  return (
    <SubscriptionContext.Provider value={{ subscription, loading, refetch: () => {
      getSubscriptionStatus().then(res => setSubscription(res.data)).catch(() => {});
    }}}>
      {children}
    </SubscriptionContext.Provider>
  );
}

export function useSubscription() {
  const context = useContext(SubscriptionContext);
  if (!context) throw new Error('useSubscription must be used within SubscriptionProvider');
  return context;
}
